<div
  class="pointer-events-none fixed inset-x-0 bottom-8 z-40 flex justify-center px-container-padding-mobile transition-all duration-300 ease-out md:px-container-padding-desktop"
  [class.opacity-0]="!visible()"
  [class.translate-y-2]="!visible()"
  [class.opacity-100]="visible()"
  [class.translate-y-0]="visible()"
  aria-live="polite"
>
  <div
    class="glass-panel flex items-center gap-3 rounded-full border border-danger/30 px-6 py-3 shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
  >
    <span class="material-symbols-outlined text-danger">close</span>
    <span class="font-label-mono text-label-mono text-on-surface">Você errou! Continue tentando.</span>
  </div>
</div>
